import type { DemoKey } from './keys';

export const ro: Partial<Record<DemoKey, string>> = {
  'app.eyebrow': 'Geometrie · 3D',
  'panel.figure': 'Figură',
  'panel.dims': 'Dimensiuni',
  'panel.style': 'Aspect',
  'panel.lines': 'Linii speciale',
  'style.body': 'Corp',
  'style.line': 'Linie',
  'style.cut': 'Secțiune',
  'style.labels': 'Notații vârfuri',
  'group.face': 'Diagonale ale fețelor / generatoare',
  'group.space': 'Diagonale / axe / mediane',
  'split.label': 'Secționare',
  'btn.animate': 'Animează',
  'btn.reset': 'Resetează',
  'hint.line1': 'Drag pentru rotire · Scroll pentru zoom',
  'hint.line2': 'Click pe o linie pentru a o selecta',
  'fig.cuboid': 'Paralelipiped dreptunghic',
  'fig.cube': 'Cub',
  'fig.triPrism': 'Prismă triunghiulară',
  'fig.hexPrism': 'Prismă hexagonală',
  'fig.tetrahedron': 'Tetraedru',
  'fig.squarePyramid': 'Piramidă patrulateră',
  'fig.cylinder': 'Cilindru',
  'fig.cone': 'Con',
  'fig.sphere': 'Sferă',
  'fig.frustumPyramid': 'Trunchi de piramidă',
  'fig.frustumCone': 'Trunchi de con',
  'dim.length': 'lungime',
  'dim.width': 'lățime',
  'dim.height': 'înălțime',
  'dim.side': 'latură',
  'dim.radius': 'rază',
  'dim.r1': 'rază jos',
  'dim.r2': 'rază sus',
  'dim.sideBase': 'latură bază',
  'dim.sideTop': 'latură top',
  'info.face': 'față',
  'info.center': 'prin centru',
  'info.diagonal': 'diagonală',
  'info.axial': 'diagonală axială',
  'info.diameter': 'diametru',
  'info.generator': 'generatoare',
  'info.axis': 'axă',
  'info.height': 'înălțime',
  'info.median': 'mediană',
  'info.apothem': 'apotemă',
  'info.diameterBase': 'diametru bază',
  'info.diameterTop': 'diametru top',
};
